import { Box } from "@mui/system";
import { Fragment } from "react";
import CustomFieldForm from "./CustomFieldForm";

export default function CustomFieldContent({ customFields, filterCustomFieldList, customFieldsInput, handleClose, handleCustomFieldFormData }) {

    return (
        <Fragment>
            <Box sx={{ mb: '20px' }}>
                <CustomFieldForm
                    customFields={customFields}
                    filterCustomFieldList={filterCustomFieldList}
                    handleClose={handleClose}
                    customFieldsInput={customFieldsInput}
                    handleCustomFieldFormData={handleCustomFieldFormData}
                />
            </Box>
        </Fragment>
    );
}


